// src/pages/novoEvento/novoEvento.schema.js
import { uuid } from "../../../utils/uuid"; 

export const ONURB_NOTICE_DEFAULT = `ATENÇÃO:

• A ONURB PASS não faz parte da organização do evento e não se responsabiliza pelo mesmo, em nível algum, nem pelas informações emitidas pelos organizadores. Mudanças de horário/local são responsabilidade do organizador.

• O organizador/produtor é exclusivamente responsável pelo evento e pela conformidade legal e normativa aplicável (alvarás, licenças, autorizações para menores etc.).

• É obrigatória apresentação do ingresso (impresso ou digital) junto com DOCUMENTO OFICIAL COM FOTO.

• É proibida a venda de bebidas alcoólicas para menores de 18 anos.

• A entrada de menores segue as regras do organizador e da legislação local. Consulte sempre o organizador e certifique-se de eventuais autorizações exigidas.

• Não comparecer invalida o ingresso e não permite reembolso.

• Reembolso: até 7 dias corridos após a compra (direito de arrependimento) e no máximo até 48 horas antes do evento. Após esse prazo, não haverá devolução.

• PCD: entradas seguem a legislação vigente (Lei 12.933/2013 e Decreto 8.537/15) mediante comprovação.

Dúvidas: suporte ONURB PASS via WhatsApp: 0800 232 0800`;

export const novoEventoInitialState = {
    status: "draft", // draft | published | finished | cancelled

    identidade: {
        titulo: "",
        categoria: "", // festa, show, esporte...
        classificacao: "18",
        tags: [], // chips
        banner: {
            mode: "url", // url | file
            url: "",
            file: null, // File
            previewUrl: "", // para mostrar imagem
        },
    },

    dataLocal: {
        dataInicio: "", // yyyy-mm-dd
        horaInicio: "", // HH:mm
        dataFim: "",
        horaFim: "",
        aberturaPortoes: "",
        local: {
            nome: "",
            endereco: "",
            cidade: "",
            estado: "",
            referencia: "",
            mapsUrl: "",
        },
    },

    descricao: {
        texto: "",
        lineup: [], // strings "22h - DJ..."
        observacoes: "",
    },

    ingressos: [
        {
            id: uuid(),
            nome: "",
            lote: "Lote 1",
            preco: 0,
            quantidade: 0,
            vendas: {
                inicio: "",
                fim: "",
            },
            taxaAbsorvidaOrganizador: false,
            visibilidade: "publico", // publico | oculto
        },
    ],

    vendas: {
        pontosFisicos: [], // strings
        comissarios: [{ id: uuid(), nome: "", phone: "" }],
        limitePorUsuario: 2,
        taxaOnurbPercent: 3, // default 3%
    },

    regras: {
        permiteMenores: false,
        detalhesMenores: "",
        politicaReembolso: "padrao", // padrao | personalizada
        reembolsoPersonalizado: "",
        avisoImportante: ONURB_NOTICE_DEFAULT,
    },

    seo: {
        slug: "",
    },
};
